/**
 *
 * OrderSummaryLineItem
 *
 */

// Node_Module Imports
import React from 'react';
import PropTypes from 'prop-types';

import './OrderSummaryLineItem.scss';

const OrderSummaryLineItem = ({ priceLabel, price, className, isOrderTotal, elementLocator }) => (
  <div
    className={`order-summary-line-item ${className}`}
    data-locator={`order-summary-line-${elementLocator}`}
  >
    <div
      className="order-summary-price-label"
      data-locator={`order-summary-label-${elementLocator}`}
    >
      {priceLabel}
    </div>
    <div
      className={`order-summary-price-value ${isOrderTotal ? 'order-summary-total-price' : ''}`}
      data-locator={`order-summary-price-${elementLocator}`}
    >
      {price}
    </div>
  </div>
);

OrderSummaryLineItem.propTypes = {
  priceLabel: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  isOrderTotal: PropTypes.bool,
  elementLocator: PropTypes.string,
};

OrderSummaryLineItem.defaultProps = {
  priceLabel: '',
  price: '--.--',
  className: '',
  isOrderTotal: false,
  elementLocator: '',
};

export default OrderSummaryLineItem;
